<template>
  <div class="dynamic-tables">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget>
      <DataTable
        class="p-datatable-sm"
        :value="getSolarPanels"
        :paginator="true"
        :filters="filters"
        :loading="loading"
        :scrollable="true"
        scrollHeight="650px"
        :rows="1000"
        dataKey="id"
        :rowHover="true"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[25, 50, 100, 1000]"
        currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Einträgen"
      >
        <template #header>
          <div class="table-header">
            <div class="table-header-left">
              <h1 class="page-title">{{ $t('solarPanels') }}</h1>
            </div>
            <div class="table-header-right">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText type="text" v-model="filters['global']" :placeholder="$t('search')" />
              </span>
              <div class="button-right">
                <router-link
                  class="btn btn-success mb-2 right"
                  :to="{ name: 'SolarPanelCreatePage' }"
                >
                  <i class="fa fa-plus-circle mr-2"></i>
                  {{ $t('solarPanelCreate') }}
                </router-link>
              </div>
            </div>
          </div>
        </template>
        <template #empty>
          {{ $t('no_data_found') }}
        </template>
        <template #loading>
          {{ $t('loading') }}
        </template>

        <Column field="number" header="#" sortable filterMatchMode="contains">
          <template #body="slotProps">
            <router-link
              :to="{
                name: 'SolarPanelEditPage',
                params: { solarPanelNumber: slotProps.data.number },
              }"
              >{{ slotProps.data.number.toString().padStart(4, '0') }}</router-link
            >
          </template>
          <template #filter>
            <InputText type="text" v-model="filters['number']" class="p-column-filter" />
          </template>
        </Column>

        <Column
          field="manufacturer"
          :header="$t('manufacturer')"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText type="text" v-model="filters['manufacturer']" class="p-column-filter" />
          </template>
        </Column>

        <Column field="type" :header="$t('type')" sortable filterMatchMode="contains">
          <template #filter>
            <InputText type="text" v-model="filters['type']" class="p-column-filter" />
          </template>
        </Column>

        <Column field="power" :header="$t('power')" sortable filterMatchMode="startsWith">
          <template #filter>
            <InputText type="text" v-model="filters['power']" class="p-column-filter" />
          </template>
        </Column>
      </DataTable>
    </Widget>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';

export default {
  name: 'SolarPanelsPage',
  components: {
    Breadcrumbs,
    DataTable,
    Widget,
    InputText,
    Column,
  },
  data() {
    return {
      loading: true,
      filters: {},
    };
  },
  computed: {
    ...mapGetters(['isLoading', 'getSolarPanels']),
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('solarPanels') }];
    },
  },
  methods: {
    ...mapActions(['fetchSolarPanels']),
  },
  async created() {
    await this.fetchSolarPanels();
    this.loading = false;
  },
};
</script>

<style scoped lang="scss">
::v-deep .p-datatable .p-datatable-thead > tr > th:nth-child(1),
::v-deep .p-datatable .p-datatable-tbody > tr > td:nth-child(1) {
  width: 60px;
  text-align: center;
}
::v-deep .p-datatable .p-datatable-thead > tr > th:nth-child(4),
::v-deep .p-datatable .p-datatable-tbody > tr > td:nth-child(4) {
  width: 10%;
  text-align: center;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
.table-header-left {
  display: flex;
  justify-content: flex-start;
}
.table-header-right {
  display: flex;
  justify-content: flex-end;
  column-gap: 1em;
}
</style>
